import type {WorkoutSeriesRange} from '../application/ports/workout.repository';
import type {CatalogExerciseSource} from '../domain/catalog-exercise-source.value-object';
import type {ExerciseId} from '../domain/exercise-id.value-object';
import type {WorkoutId} from '../domain/workout-id.value-object';
import type {WorkoutTemplateId} from '../domain/workout-template-id.value-object';

export const keys = {
  templates: {
    list: () => ['workouts', 'templates', 'list'] as const,
    detail: (templateId: WorkoutTemplateId) =>
      ['workouts', 'templates', 'detail', templateId] as const,
  },
  active: () => ['workouts', 'active'] as const,
  focusMode: () => ['workouts', 'focus-mode'] as const,
  keepScreenAwake: () => ['workouts', 'keep-screen-awake'] as const,
  detail: (workoutId: WorkoutId) => ['workouts', 'detail', workoutId] as const,
  /** Prefix for all series queries (any date range). */
  seriesAll: () => ['workouts', 'series'] as const,
  series: (range: WorkoutSeriesRange) => [...keys.seriesAll(), range.from, range.to] as const,
  catalogExercises: {
    all: () => ['workouts', 'catalog-exercises'] as const,
    list: (source: CatalogExerciseSource, query: string) =>
      [...keys.catalogExercises.all(), 'list', source, query] as const,
    detail: (exerciseId: ExerciseId) =>
      [...keys.catalogExercises.all(), 'detail', exerciseId] as const,
  },
  catalogMuscles: {
    list: () => ['workouts', 'catalog-muscles', 'list'] as const,
  },
  mutations: {
    createTemplate: () => ['workouts', 'mutations', 'create-template'] as const,
    updateTemplate: () => ['workouts', 'mutations', 'update-template'] as const,
    replaceTemplateExercises: () =>
      ['workouts', 'mutations', 'replace-template-exercises'] as const,
    deleteTemplate: () => ['workouts', 'mutations', 'delete-template'] as const,
    duplicateTemplate: () => ['workouts', 'mutations', 'duplicate-template'] as const,
    createCustomExercise: () => ['workouts', 'mutations', 'create-custom-exercise'] as const,
    updateCustomExercise: () => ['workouts', 'mutations', 'update-custom-exercise'] as const,
    deleteCustomExercise: () => ['workouts', 'mutations', 'delete-custom-exercise'] as const,

    startFromTemplate: () => ['workouts', 'mutations', 'start-from-template'] as const,
    discard: () => ['workouts', 'mutations', 'discard'] as const,
    logSet: () => ['workouts', 'mutations', 'log-set'] as const,
    updateSet: () => ['workouts', 'mutations', 'update-set'] as const,
    deleteSet: () => ['workouts', 'mutations', 'delete-set'] as const,
    reorderExercises: () => ['workouts', 'mutations', 'reorder-exercises'] as const,
    removeExercise: () => ['workouts', 'mutations', 'remove-exercise'] as const,
    complete: () => ['workouts', 'mutations', 'complete'] as const,
    addExercise: () => ['workouts', 'mutations', 'add-exercise'] as const,
    replaceExercise: () => ['workouts', 'mutations', 'replace-exercise'] as const,
    setFocusMode: () => ['workouts', 'mutations', 'set-focus-mode'] as const,
    setKeepScreenAwake: () => ['workouts', 'mutations', 'set-keep-screen-awake'] as const,
  },
} as const;
